import React from 'react';
import { Link } from 'react-router-dom';

import {
  Container,
  VerticalContainer,
  VerticalContent,
  Content,
  ImageContent,
  ImageOne,
  ImageTwo,
  ContentContainer,
  ContentInfos,
  LearnMore,
  BlueBackground,
  BlueRectangle,
  BlueRectangleMobile,
} from './styles';

import Image1 from '../../../../assets/what-we-do-1.png';
import Image2 from '../../../../assets/what-we-do-2.png';

const AboutUs: React.FC = () => {
  return (
    <Container id="what-we-do">
      <VerticalContainer>
        <VerticalContent>
          <h1>JOGOS INCRÍVEIS. GRANDES EXPERIÊNCIAS.</h1>
          <div />
        </VerticalContent>
      </VerticalContainer>

      <Content>
        <ImageContent>
          <ImageOne src={Image1} alt="Time" />
          <ImageTwo src={Image2} alt="Time" />

          <BlueRectangleMobile />
        </ImageContent>

        <ContentContainer>
          <ContentInfos>
            <h1>O QUE FAZEMOS</h1>
            <p>
              Jogos são divertidos e experiências incríveis surgem a partir
              deles. A proposta da Karbon é justamente essa: proporcionar novas
              experiências por meio dos nossos projetos.
            </p>

            <LearnMore>
              <Link to="/nos">SAIBA MAIS</Link>
            </LearnMore>
          </ContentInfos>
          <BlueBackground>
            <div>
              <h1>.02</h1>
            </div>
          </BlueBackground>
        </ContentContainer>
      </Content>

      <BlueRectangle />
    </Container>
  );
};

export default AboutUs;
